import { createContext, useContext, useState } from 'react';

const AIChatContext = createContext(null);

export const AIChatProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [messages, setMessages] = useState([
        {
            id: '1',
            role: 'assistant',
            content: 'Hello! I\'m FlowWire AI. Ask me about your diagram, run simulations, or open economics.'
        }
    ]);
    const [pendingAction, setPendingAction] = useState(null);

    const toggleOpen = () => setIsOpen(prev => !prev);
    const close = () => setIsOpen(false);

    const addMessage = (message) => {
        setMessages(prev => [...prev, message]);
    };

    const clearMessages = () => {
        setMessages([{
            id: '1',
            role: 'assistant',
            content: 'Hello! I\'m FlowWire AI. Ask me about your diagram, run simulations, or open economics.'
        }]);
    };

    const consumePendingAction = () => {
        const action = pendingAction;
        setPendingAction(null);
        return action;
    };

    return (
        <AIChatContext.Provider value={{
            isOpen,
            setIsOpen,
            toggleOpen,
            close,
            isCollapsed,
            setIsCollapsed,
            messages,
            setMessages,
            addMessage,
            clearMessages,
            pendingAction,
            setPendingAction,
            consumePendingAction
        }}>
            {children}
        </AIChatContext.Provider>
    );
};

export const useAIChat = () => {
    const context = useContext(AIChatContext);
    if (!context) {
        throw new Error('useAIChat must be used within an AIChatProvider');
    }
    return context;
};
